import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-40aa6518")

_pushScopeId("data-v-40aa6518")
const _hoisted_1 = { class: "TTN" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "TTN__title" }, "Остановки", -1)
const _hoisted_3 = { class: "item__header" }
const _hoisted_4 = { class: "item__title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Конечный пункт")
const _hoisted_6 = { class: "header__actions" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Распечатать накладную ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Распечатать ТТН ")
const _hoisted_9 = { class: "item__body" }
const _hoisted_10 = { class: "body__block" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Номер ТТН", -1)
const _hoisted_12 = { class: "block__text" }
const _hoisted_13 = { class: "body__block" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Наименование получателя", -1)
const _hoisted_15 = { class: "block__text" }
const _hoisted_16 = { class: "body__block" }
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Телефон получателя", -1)
const _hoisted_18 = { class: "block__text" }
const _hoisted_19 = { class: "body__block" }
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Контактное лицо", -1)
const _hoisted_21 = { class: "block__text" }
const _hoisted_22 = { class: "body__block" }
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Адрес получателя", -1)
const _hoisted_24 = { class: "block__text" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createVNode("h2", { class: "TTN__title" }, "Доп. услуги", -1)
const _hoisted_27 = { class: "body__services" }
const _hoisted_28 = { class: "block__subtext" }
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "block__text" }, "Да", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_button = _resolveComponent("s-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
      return (_openBlock(), _createBlock("div", {
        class: "TTN__item",
        key: `StockDeliveryNote-${i}`
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h2", _hoisted_4, [
            (item.receiver.is_endpoint)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_5
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" Промежуточный пункт " + _toDisplayString(i + 1), 1)
                ], 64))
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_s_button, {
              class: "green small",
              disabled: _ctx.is_print_invoices_loading,
              loading: _ctx.is_print_invoices_loading,
              onClick: ($event: any) => (_ctx.printFtlOrderStockDeliveryNote(i))
            }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["disabled", "loading", "onClick"]),
            _createVNode(_component_router_link, {
              target: "_blank",
              to: `/ttn/${item.id}/print`
            }, {
              default: _withId(() => [
                _createVNode(_component_s_button, { class: "green small" }, {
                  default: _withId(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("p", _hoisted_12, _toDisplayString(item.number) + " (" + _toDisplayString(item.directionName) + ")", 1)
          ]),
          _createVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode("p", _hoisted_15, _toDisplayString(item.receiver.title), 1)
          ]),
          _createVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode("p", _hoisted_18, _toDisplayString(_ctx.toPhone(item.receiver.phone)), 1)
          ]),
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode("p", _hoisted_21, _toDisplayString(item.receiver.full_name) + " " + _toDisplayString(_ctx.toPhone(item.receiver.phone)), 1)
          ]),
          _createVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode("p", _hoisted_24, _toDisplayString(item.receiver.address), 1)
          ]),
          (item.additional_service.length)
            ? (_openBlock(), _createBlock("div", _hoisted_25, [
                _hoisted_26,
                _createVNode("div", _hoisted_27, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.additional_service, (service, i) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "body__service",
                      key: `item-service-${i}`
                    }, [
                      _createVNode("p", _hoisted_28, _toDisplayString(service.type_name), 1),
                      _hoisted_29
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
})